import React from "react";

function CommonBanner({ title }) {
  return (
    <section className="country-banner">
      <div
        className="banner-details"
        style={{
          backgroundImage: "url('/images/webp/legislation-banner.webp')",
        }}
      >
        <div className="position-relative">
          <h2 className="f-s-36 f-w-400 py-sm-5 py-4 mb-0">{title}</h2>
        </div>
      </div>
    </section>
  );
}

export default CommonBanner;
